<!-- Modal -->
<div class="modal-box">
   <h2 mat-dialog-title>Share</h2>
   <mat-dialog-content>
      <div class="grid grid-cols-3 gap-3">
         <button class="dialog-btn" (click)="open('whatsapp')"><img src="/assets/images/social-icon/whatsapp.png" /></button>
         <button class="dialog-btn" (click)="open('telegram')"><img src="/assets/images/social-icon/telegram.png" /></button>
         <button class="dialog-btn" (click)="open('facebook')"><img src="/assets/images/social-icon/facebook.png" /></button>
         <button class="dialog-btn" (click)="open('twitter')"><img src="/assets/images/social-icon/x.png" /></button>
         <button class="dialog-btn" (click)="open('email')"><img src="/assets/images/social-icon/email.png" /></button>
         <button class="dialog-btn"
                 [cdkCopyToClipboard]="data.url"
                 (cdkCopyToClipboardCopied)="onCopied($event)">
            <p style="font-size: 12px; margin-top: 10px;">Copy Link</p>
         </button>
      </div>
      <p style="margin-top:12px; word-break:break-all; font-size: 12px;">{{ data.url }}</p>
   </mat-dialog-content>
   <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
   </mat-dialog-actions>
</div>